module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"page_title":"船長からのお便り","date":"日時","title":"タイトル","mark_as_read":"既読にする"},"en":{"page_title":"Messages from the Capt.","date":"Date","title":"Title","mark_as_read":"Mark as Read"}}')
  delete Component.options._Ctor
}
